// extracted by mini-css-extract-plugin
module.exports = {"durationForm":"DurationForm_durationForm__1wX0Z","durationLabel":"DurationForm_durationLabel__3UoZi"};